import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {IContent} from './contents';

@Injectable()
export class ContentsService {

    constructor(
        private http: HttpClient
    ) {
    }

    list(withExpired: boolean = false): Observable<IContent[]> {
        const options: any = <any>{};
        if (withExpired) {
            options.params = {all: 1};
        }
        return <any>this.http.get(environment.api + '/contents', options);
    }

    item(contentId: number): Observable<IContent> {
        return <any>this.http.get(environment.api + '/contents/' + contentId);
    }

    save(content: IContent): Observable<IContent> {
        return content.id ? this.edit(content) : this.add(content);
    }

    add(content: IContent): Observable<IContent> {
        return <any>this.http.post(environment.api + '/contents', content);
    }

    edit(content: IContent): Observable<IContent> {
        return <any>this.http.put(environment.api + '/contents/' + content.id, content);
    }

    toggle(content: IContent): Observable<IContent> {
        return <any>this.http.put(environment.api + '/contents/' + content.id + '/active', null);
    }

    remove(contentId: number): Observable<IContent> {
        return <any>this.http.delete(environment.api + '/contents/' + contentId);
    }

    upload(formData: FormData): Observable<{ path: string }> {
        return <any>this.http.post(environment.api + '/contents/image', formData);
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/administration/contents/contents.service.ts